import styled from 'styled-components'

export const EventsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
